const PhoneNumber = "(13) 3821-4411";
const EmailAdress = "contato@alfadiagnostica.com.br";

export { PhoneNumber, EmailAdress };